// extracted by mini-css-extract-plugin
export default {"app":"Main_app__QQGTP","products":"Main_products__uc-CQ","productsMobile":"Main_productsMobile__PIe11"};